var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_859_1631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8654 7.61283C14.9146 7.61283 15.7651 6.76229 15.7651 5.71309C15.7651 4.6639 14.9146 3.81335 13.8654 3.81335C12.8162 3.81335 11.9656 4.6639 11.9656 5.71309C11.9656 6.76229 12.8162 7.61283 13.8654 7.61283Z",
    fill: "#666EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90242 3.79947C10.9516 3.79947 11.8022 2.94893 11.8022 1.89974C11.8022 0.850541 10.9516 0 9.90242 0C8.85323 0 8.00269 0.850541 8.00269 1.89974C8.00269 2.94893 8.85323 3.79947 9.90242 3.79947Z",
    fill: "#666EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90242 20C10.9516 20 11.8022 19.1495 11.8022 18.1003C11.8022 17.0511 10.9516 16.2006 9.90242 16.2006C8.85323 16.2006 8.00269 17.0511 8.00269 18.1003C8.00269 19.1495 8.85323 20 9.90242 20Z",
    fill: "#666EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8609 15.3778H8.7314C7.75007 15.3778 6.8168 14.9057 6.23523 14.1156C5.80278 13.5261 5.10778 12.4105 4.82888 11.9582C4.21909 10.969 4.16806 9.71173 4.69563 8.6774L4.7204 8.62885C5.38122 7.33347 5.87708 6.3784 6.2387 5.8855C6.81927 5.0944 7.75255 4.62231 8.73536 4.62231H13.8639V6.80293H8.73635C8.44507 6.80293 8.16915 6.94262 7.99775 7.17594C7.71242 7.5648 7.10659 8.7527 6.66422 9.62009L6.63945 9.66863C6.45518 10.0293 6.47351 10.4682 6.68651 10.8144C7.23786 11.7091 7.72629 12.4605 7.9933 12.8241C8.16469 13.0574 8.44111 13.1971 8.73189 13.1971H13.8609V15.3778Z",
    fill: "#666EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8609 16.1872C14.9101 16.1872 15.7607 15.3366 15.7607 14.2874C15.7607 13.2382 14.9101 12.3877 13.8609 12.3877C12.8117 12.3877 11.9612 13.2382 11.9612 14.2874C11.9612 15.3366 12.8117 16.1872 13.8609 16.1872Z",
    fill: "#666EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.534 19.1906H7.34039C5.79335 19.1906 4.32211 18.4465 3.40568 17.2007C2.60962 16.1163 1.31374 14.0358 0.793103 13.1912C-0.182277 11.608 -0.264013 9.59679 0.580095 7.94275L0.62765 7.84962C1.60997 5.92363 2.72355 3.74054 3.4141 2.80033C4.32954 1.55399 5.80029 0.809448 7.3493 0.809448H10.542V2.99006H7.3493C6.49182 2.99006 5.67793 3.40171 5.17166 4.09077C4.58614 4.88831 3.46809 7.07932 2.56999 8.83986L2.52243 8.93299C2.02211 9.91382 2.07066 11.1072 2.64974 12.0464C3.70438 13.7579 4.6436 15.2014 5.16275 15.9088C5.66951 16.5973 6.4834 17.0095 7.33989 17.0095H10.5335V19.1906H10.534Z",
    fill: "#666EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90242 11.9002C10.9516 11.9002 11.8022 11.0496 11.8022 10.0004C11.8022 8.95125 10.9516 8.10071 9.90242 8.10071C8.85323 8.10071 8.00269 8.95125 8.00269 10.0004C8.00269 11.0496 8.85323 11.9002 9.90242 11.9002Z",
    fill: "#666EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99347 8.90967H1.49652V11.0903H5.99347V8.90967Z",
    fill: "#666EDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_859_1631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7651,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/company_icon.fc7c232afa5e24f21c3d2c42899ffc8a.svg";
export { ForwardRef as ReactComponent };